import { useEffect, useMemo, useState, useRef } from "react";
import { useCarrito } from "../context/CarritoContext";
import MapaSucursales from "../components/MapaSucursales";
import ShippingEstimator from "../components/ShippingEstimator";
import { useNavigate } from "react-router-dom";


/*
const provincias = [
  "Buenos Aires", "CABA", "Catamarca", "Chaco", "Chubut", "Córdoba", "Corrientes", "Entre Ríos",
  "Formosa", "Jujuy", "La Pampa", "La Rioja", "Mendoza", "Misiones", "Neuquén", "Río Negro",
  "Salta", "San Juan", "San Luis", "Santa Cruz", "Santa Fe", "Santiago del Estero", "Tierra del Fuego", "Tucumán"
]; */

// Formatea 8404 -> "8.404,00"
const formatAr = (n) =>
  n == null
    ? "—"
    : Number(n).toLocaleString("es-AR", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });



export default function Checkout() {
  const navigate = useNavigate();

  const {
    carrito, setCarrito,
    provincia, setProvincia,
    cp: codigoPostal, setCp: setCodigoPostal,
    metodoEntrega, setMetodoEntrega,
    servicio, setServicio,
    precioEnvio, setPrecioEnvio,
  } = useCarrito();

  // === Helpers NUEVOS ===
  const getQty = (it) => Math.max(1, Number(it?.cantidad ?? it?.qty ?? it?.quantity ?? 1));
  const parsePrecio = (v) => {
    if (typeof v === "number") return v;
    const s = String(v ?? "").replace(/[^\d.,-]/g, "");
    const n = parseFloat(s.replace(/\./g, "").replace(/,/g, "."));
    return Number.isFinite(n) ? n : 0;
  };

  const precio30Off = (n) => Math.floor((n * 0.70) / 100) * 100;

  // === Umbral envío gratis a domicilio (se mantiene)
  const FREE_SHIPPING_THRESHOLD = 175000;

  // Eliminar producto por índice
  const eliminarDelCarrito = (index) => {
    setCarrito((prev) => prev.filter((_, i) => i !== index));
  };

  // ====== Estado del checkout ======
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [telefono, setTelefono] = useState(""); // opcional
  const [dni, setDni] = useState("");

  // Dirección para domicilio
  const [calle, setCalle] = useState("");
  const [numero, setNumero] = useState("");
  const [pisoDepto, setPisoDepto] = useState(""); // opcional
  const [referencia, setReferencia] = useState(""); // opcional
  const [localidad, setLocalidad] = useState("");

  // Sucursal elegida (si corresponde)
  const [sucursalSeleccionada, setSucursalSeleccionada] = useState(null);
  const [resultadosSucursales, setResultadosSucursales] = useState([]);
  const [focusPlace, setFocusPlace] = useState(null);

  // === Refs para auto-scroll a "Sucursal seleccionada"
  const selAnchorMobileRef = useRef(null);
  const selAnchorDesktopRef = useRef(null);

  // ✅ Totales productos (precio × cantidad)
  const totalProductos = carrito.reduce((acc, item) => {
    const precioOriginal = parsePrecio(item.precio);
    const precioConOff = precio30Off(precioOriginal);
    const qty = getQty(item);
  return acc + precioConOff * qty;
  }, 0);

  // === Envío gratis a domicilio por umbral
  const envioGratisDomicilio = totalProductos >= FREE_SHIPPING_THRESHOLD;

  // === Precio de envío final
  const precioEnvioFinal =
    metodoEntrega === "sucursal"
      ? 0
      : (metodoEntrega === "domicilio" && envioGratisDomicilio
          ? 0
          : (precioEnvio ?? 0));

  // Totales
  const total = totalProductos + precioEnvioFinal;

  // Total con transferencia (15% OFF sobre productos) + envío
  const totalTransfer = totalProductos * 0.85 + precioEnvioFinal;

  const validarEmail = (correo) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(correo);
  const validarDNI = (v) => /^\d{7,8}$/.test(v);

  // Si cambia zona (provincia/CP), invalidamos envío y sucursal elegida
  useEffect(() => {
    setPrecioEnvio(null);
    if (sucursalSeleccionada) setSucursalSeleccionada(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provincia, codigoPostal]);

  // Cuando cambian el método de entrega, seteo el envío acorde
  useEffect(() => {
    if (metodoEntrega === "sucursal") {
      setPrecioEnvio(0); // Sucursal siempre gratis
    } else if (metodoEntrega === "domicilio") {
      setPrecioEnvio(envioGratisDomicilio ? 0 : null); // Forzar recálculo
    }
  }, [metodoEntrega, envioGratisDomicilio, setPrecioEnvio]);

  // Dirección completa (para el backend)
  const direccionCompleta = useMemo(() => {
    const base = `${(calle || "").trim()} ${(numero || "").trim()}`.trim();
    const extra = pisoDepto ? `, ${pisoDepto.trim()}` : "";
    return (base + extra).trim();
  }, [calle, numero, pisoDepto]);

  // === Auto-scroll cuando se selecciona sucursal (SE MANTIENE)
  useEffect(() => {
    if (!sucursalSeleccionada) return;
    const isDesktop = window.matchMedia("(min-width: 768px)").matches;
    const el = isDesktop ? selAnchorDesktopRef.current : selAnchorMobileRef.current;
    if (el && !isDesktop) { // en desktop NO scrollea
      el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    }
  }, [sucursalSeleccionada]);

  // Inputs
  const inputSm = "w-full border rounded-lg px-2 py-1.5 text-base md:text-sm";
  const labelSm = "block text-xs font-medium mb-1";

  

  // === Habilitar Iniciar pago
  const puedeIniciarPago =
    nombre &&
    email &&
    validarEmail(email) &&
    dni &&
    validarDNI(dni) &&
    provincia &&
    localidad &&
    codigoPostal.length >= 4 &&
    (metodoEntrega === "domicilio"
      ? (calle && numero && (precioEnvio !== null || envioGratisDomicilio))
      : (metodoEntrega === "sucursal" ? !!sucursalSeleccionada : false));

  // ✅ Normalizar carrito antes de ir a pago (asegura cantidad para la próxima pantalla/backend)
  const irAPago = () => {
    if (!puedeIniciarPago) return;
    const carritoNorm = carrito.map((it) => {
      const q = getQty(it);
      return { ...it, cantidad: q, qty: q, quantity: q };
    });
    navigate("/pago", {
      state: {
        carrito: carritoNorm, // 👈 ahora SIEMPRE llevará la cantidad correcta
        provincia, localidad, codigoPostal,
        metodoEntrega, servicio,
        precioEnvio:
          metodoEntrega === "sucursal"
            ? 0
            : (envioGratisDomicilio ? 0 : (precioEnvio ?? null)),
        nombre, email, telefono, dni,
        calle, numero, pisoDepto, referencia,
        sucursalSeleccionada
      }
    });
  };

  return (
    <div className="max-w-6xl mx-auto px-8 md:px-6 pt-28 md:pt-36">
      <h1 className="text-md font-semibold nav-onepalm text-yellow-900 mb-6 text-center">
        Completá tu pedido
      </h1>

      <div className="flex flex-col md:flex-row gap-8">
        {/* IZQUIERDA */}
        <div className="w-full md:w-[70%]">
          <form className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {/* Método de entrega */}
            <div>
              <label className={labelSm}>Método de entrega</label>
              <select
                value={metodoEntrega}
                onChange={(e) => setMetodoEntrega(e.target.value)}
                className={inputSm}
              >
                <option value="domicilio">Entrega en domicilio</option>
                <option value="sucursal">Retiro en sucursal</option>
              </select>

              {/* Avisos */}
              {metodoEntrega === "domicilio" && envioGratisDomicilio && (
                <p className="text-xs text-green-700 mt-1">
                  Envío gratis a domicilio aplicado
                </p>
              )}
              {metodoEntrega === "sucursal" && (
                <p className="text-xs text-green-700 mt-1">
                  <strong>Gratis $0,00</strong>
                </p>
              )}
            </div>

            <div className="md:col-span-1">
              <label className={labelSm}>Nombre y apellido</label>
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                className={inputSm}
              />
            </div>

            <div>
              <label className={labelSm}>Provincia</label>
              <select
                value={provincia}
                onChange={(e) => setProvincia(e.target.value)}
                className={inputSm}
              >
                <option value="">Seleccioná una provincia</option>
                {[
                  "Buenos Aires","CABA","Catamarca","Chaco","Chubut","Córdoba","Corrientes",
                  "Entre Ríos","Formosa","Jujuy","La Pampa","La Rioja","Mendoza","Misiones",
                  "Neuquén","Río Negro","Salta","San Juan","San Luis","Santa Cruz","Santa Fe",
                  "Santiago del Estero","Tierra del Fuego","Tucumán",
                ].map((prov) => (
                  <option key={prov} value={prov}>{prov}</option>
                ))}
              </select>
            </div>

            <div>
              <label className={labelSm}>Localidad</label>
              <input
                type="text"
                value={localidad}
                onChange={(e) => setLocalidad(e.target.value)}
                className={inputSm}
              />
            </div>

            <div>
              <label className={labelSm}>CP / CPA</label>
              <input
                type="text"
                value={codigoPostal}
                onChange={(e) => setCodigoPostal(e.target.value)}
                className={inputSm}
              />
            </div>

            {/* ====== MOBILE: Mapa+Lista (solo si sucursal) ====== */}
            {metodoEntrega === "sucursal" &&
              provincia &&
              localidad &&
              codigoPostal.trim().length >= 4 && (
                <div className="md:col-span-3 mt-3 bg-transparent p-0 rounded-xl md:rounded-2xl md:p-4 md:hidden">
                  <div className="block text-sm font-medium mb-1">Seleccionar sucursal</div>
                  <div className="grid grid-cols-1 gap-3 mt-2">
                    {/* MAPA */}
                    <div className="h-[46vh] rounded-xl overflow-hidden border bg-white">
                      <MapaSucursales
                        provincia={provincia}
                        localidad={localidad}
                        metodoEntrega={metodoEntrega}
                        sucursales={[]}
                        onSelect={(s) => setSucursalSeleccionada(s)}
                        onResults={(list) => setResultadosSucursales(list)}
                        focusPlace={focusPlace}
                      />
                    </div>

                    {/* LISTA */}
                    <div className="bg-white rounded-xl p-3 border max-h-56 overflow-auto">
                      <div className="text-sm font-medium mb-2">Seleccionar sucursal</div>

                      {resultadosSucursales?.length ? (
                        <ul className="space-y-2">
                          {resultadosSucursales.map((p) => (
                            <li
                              key={p.place_id}
                              className={`p-2 rounded-lg border ${
                                sucursalSeleccionada?.placeId === p.place_id
                                  ? "border-black"
                                  : "border-gray-200"
                              }`}
                            >
                              <div className="text-sm font-semibold leading-tight">{p.name}</div>
                              <div className="text-xs opacity-80 mb-2 overflow-hidden text-ellipsis whitespace-nowrap">
                                {p.formatted_address || p.vicinity || ""}
                              </div>
                              <button
                                type="button"
                                className="text-xs px-2 py-1 rounded-md bg-black text-white"
                                onClick={() => {
                                  setFocusPlace(p);
                                  const rawLoc = p?.geometry?.location;
                                  const lat =
                                    typeof rawLoc?.lat === "function" ? rawLoc.lat()
                                    : (typeof rawLoc?.lat === "number" ? rawLoc.lat : null);
                                  const lng =
                                    typeof rawLoc?.lng === "function" ? rawLoc.lng()
                                    : (typeof rawLoc?.lng === "number" ? rawLoc.lng : null);

                                  setSucursalSeleccionada({
                                    nombre: p.name,
                                    address: p.formatted_address || p.vicinity || "",
                                    lat, lng,
                                    placeId: p.place_id,
                                  });
                                }}
                              >
                                Usar esta sucursal
                              </button>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <div className="text-xs opacity-80">
                          Ingresá provincia, localidad y CP para ver sucursales.
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Ancla MOBILE para auto-scroll */}
                  <div ref={selAnchorMobileRef} className="scroll-mt-24 md:scroll-mt-0" />

                  {sucursalSeleccionada && (
                    <div className="mt-3 text-sm">
                      <span className="font-medium">Sucursal seleccionada:</span>{" "}
                      {sucursalSeleccionada?.nombre} – {sucursalSeleccionada?.address}
                    </div>
                  )}
                </div>
              )}

            {/* Datos de contacto */}
            <div>
              <label className={labelSm}>Correo electrónico</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={inputSm}
              />
            </div>

            <div>
              <label className={labelSm}>Celular (opcional)</label>
              <input
                type="text"
                value={telefono}
                onChange={(e) => setTelefono(e.target.value)}
                className={inputSm}
              />
            </div>

            <div>
              <label className={labelSm}>DNI</label>
              <input
                type="text"
                value={dni}
                onChange={(e) => setDni(e.target.value.replace(/\D/g, ""))}
                placeholder="Solo números (7 u 8 dígitos)"
                className={inputSm}
              />
            </div>

            {/* Campos de domicilio (solo si corresponde) */}
            {metodoEntrega === "domicilio" && (
              <>
                <div>
                  <label className={labelSm}>Calle</label>
                  <input
                    type="text"
                    value={calle}
                    onChange={(e) => setCalle(e.target.value)}
                    className={inputSm}
                  />
                </div>
                <div>
                  <label className={labelSm}>Número</label>
                  <input
                    type="text"
                    value={numero}
                    onChange={(e) => setNumero(e.target.value)}
                    className={inputSm}
                  />
                </div>
                <div>
                  <label className={labelSm}>Piso/Depto (opcional)</label>
                  <input
                    type="text"
                    value={pisoDepto}
                    onChange={(e) => setPisoDepto(e.target.value)}
                    className={inputSm}
                  />
                </div>
                <div className="md:col-span-3">
                  <label className={labelSm}>Referencia (opcional)</label>
                  <input
                    type="text"
                    value={referencia}
                    onChange={(e) => setReferencia(e.target.value)}
                    className={inputSm}
                  />
                </div>
              </>
            )}
          </form>

          {/* ====== DESKTOP: Mapa+Lista (sucursal) ====== */}
          {metodoEntrega === "sucursal" && provincia && localidad && localidad.trim().length >= 3 && (
            <div className="mt-3 bg-transparent p-0 rounded-xl md:rounded-2xl md:p-4 hidden md:block">
              <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                {/* MAPA */}
                <div className="md:col-span-3 h-[46vh] md:h-80 rounded-xl overflow-hidden border bg-white">
                  <MapaSucursales
                    provincia={provincia}
                    localidad={localidad}
                    metodoEntrega={metodoEntrega}
                    sucursales={[]}
                    onSelect={(s) => setSucursalSeleccionada(s)}
                    onResults={(list) => setResultadosSucursales(list)}
                    focusPlace={focusPlace}
                  />
                </div>

                {/* LISTA */}
                <div className="md:col-span-2 bg-white rounded-xl p-3 border max-h-80 overflow-auto">
                  <div className="text-sm font-medium mb-2">Seleccionar sucursal</div>

                  {resultadosSucursales?.length ? (
                    <ul className="space-y-2">
                      {resultadosSucursales.map((p) => (
                        <li
                          key={p.place_id}
                          className={`p-2 rounded-lg border ${
                            sucursalSeleccionada?.placeId === p.place_id
                              ? "border-black"
                              : "border-gray-200"
                          }`}
                        >
                          <div className="text-sm font-semibold leading-tight">{p.name}</div>
                          <div className="text-xs opacity-80 mb-2 overflow-hidden text-ellipsis whitespace-nowrap">
                            {p.formatted_address || p.vicinity || ""}
                          </div>
                          <button
                            type="button"
                            className="text-xs px-2 py-1 rounded-md bg-black text-white"
                            onClick={() => {
                              setFocusPlace(p);
                              const rawLoc = p?.geometry?.location;
                              const lat =
                                typeof rawLoc?.lat === "function" ? rawLoc.lat()
                                : (typeof rawLoc?.lat === "number" ? rawLoc.lat : null);
                              const lng =
                                typeof rawLoc?.lng === "function" ? rawLoc.lng()
                                : (typeof rawLoc?.lng === "number" ? rawLoc.lng : null);

                              setSucursalSeleccionada({
                                nombre: p.name,
                                address: p.formatted_address || p.vicinity || "",
                                lat, lng,
                                placeId: p.place_id,
                              });
                            }}
                          >
                            Usar esta sucursal
                          </button>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="text-xs opacity-80">
                      Ingresá provincia y localidad para ver sucursales.
                    </div>
                  )}
                </div>
              </div>

              {/* Ancla DESKTOP para auto-scroll */}
              <div ref={selAnchorDesktopRef} />

              {sucursalSeleccionada && (
                <div className="mt-3 text-sm">
                  <span className="font-medium">Sucursal seleccionada:</span>{" "}
                  {sucursalSeleccionada?.nombre} – {sucursalSeleccionada?.address}
                </div>
              )}
            </div>
          )}
        </div>

        {/* DERECHA: CARRITO + RESUMEN */}
        <div className="w-full md:w-[30%] border-l pl-6">
          {carrito.length === 0 ? (
            <p className="text-gray-600">Tu carrito está vacío.</p>
          ) : (
            <>
              <ul className="space-y-4">
                {carrito.map((item, i) => {
                  const qty = getQty(item);
                  const precioUnit = precio30Off(parsePrecio(item.precio));
                  const subtotalLinea = precioUnit * qty;
                  return (
                    <li key={i} className="flex justify-between gap-3 border-b pb-1">
                      <div className="relative">
                        {/* Badge con cantidad */}
                        {qty > 1 && (
                          <span className="absolute -top-2 -right-2 text-[10px] bg-black text-white px-1.5 py-0.5">
                            x{qty}
                          </span>
                        )}
                        <img
                          src={item.img}
                          alt={item.nombre}
                          className="w-20 h-20 object-cover "
                        />
                      </div>
                      {/* Texto */}
                      <div className="flex-1">
                        <p className="proba text-xs text-black-900">{item.nombre}</p>
                        <p className="text-[9px] proba mt-1 text-gray-500">Talle: {item.talle}</p>
                        {/* Precio unitario + subtotal de línea si qty>1 */}
                        <p className="proba text-[10px] mt-1 text-gray-500">
                          ${formatAr(precioUnit)}
                          {qty > 1 && (
                            <span className="text-[10px] text-gray-500"> &nbsp;× {qty} = ${formatAr(subtotalLinea)}</span>
                          )}
                        </p>
                      </div>
                      <div className="flex flex-col items-end gap-1">
                        <button
                          type="button"
                          className="text-xs text-red-600 hover:underline"
                          onClick={() => eliminarDelCarrito(i)}
                        >
                          Quitar
                        </button>
                      </div>
                    </li>
                  );
                })}
              </ul>

              {/* Estimador de envío */}
              <div className="mt-4">
                <ShippingEstimator
                  provincia={provincia}
                  localidad={localidad}
                  cp={codigoPostal}
                  metodoEntrega={metodoEntrega}
                  onMetodoEntregaChange={setMetodoEntrega}
                  servicio={servicio}
                  onServicioChange={setServicio}
                  onPrecioChange={setPrecioEnvio}
                />
              </div>

              {/* === RESUMEN === */}
              <div className="mt-4 space-y-2">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-700 text-xs">Subtotal</span>
                  <span className="text-[10px] proba text-gray-900">
                    ${formatAr(totalProductos)}
                  </span>
                </div>

                <div className="flex items-center justify-between text-xs">
                  <span className="text-gray-700 text-xs">Envío</span>
                  <span className="font-bold text-green-700 proba text-[10px]">
                    ${formatAr(precioEnvioFinal)}
                  </span>
                </div>

                <div className="flex items-center justify-between pt-2 border-t">
                  <span className="text-gray-900 text-sm font-semibold">Total</span>
                  <span className="flex items-baseline gap-1 text-gray-700 font-medium">
                    <span className="text-sm">$</span>
                    <span className="text-xs proba font-semibold text-gray-700">{formatAr(total)}</span>
                  </span>
                </div>

                {/* En transferencia */}
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-800 font-medium">En transferencia</span>
                  <span className="text-xs font-semibold proba text-green-700">
                    ${formatAr(totalTransfer)}
                  </span>
                </div>
              </div>

              <div className="mt-6">
                <button
                  onClick={irAPago}
                  disabled={!puedeIniciarPago}
                  className="w-full nav-onepalm text-sm bg-[#ffae00] text-black px-6 py-3 shadow-md hover:shadow-lg hover:bg-[#e69c00] active:scale-95 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Iniciar pago
                </button>

                {!puedeIniciarPago && (
                  <p className="text-sm text-red-600 mt-1">
                    Completá los campos obligatorios.
                  </p>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
















